<template>
  <div>
    <b-input ref="devise" type="text" v-model="displayValue" @blur="catchBlur()"
      class="inputCurrency" :class="{ inputCurrencySaisie: isInputActive }"
      @focus="selection" :placeholder="placeholder" :disabled="disabled"
      :size="taille"/>
  </div>
</template>
<script>
import isNaN from '@/services/general/isNan';
import decimalsFormater from '@/services/general/decimalsFormater';

export default {
  name: 'input-currency',
  props: {
    value: Number,
    placeholder: String,
    disabled: Boolean,
    size: String,
    peutEtreNegatif: Boolean,
    symbole: {
      type: String,
      required: false,
      default: '',
    },
    checkBlur: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isInputActive: false,
    };
  },
  computed: {
    displayValue: {
      get() {
        if (!this.value && this.value !== 0) {
          return null;
        }
        if (this.isInputActive) {
          return this.value.toString();
        }
        return decimalsFormater(this.value).toString().replace('.', ',') + this.symbole;
      },
      set(modifiedValue) {
        if (!modifiedValue) {
          this.$emit('input', null);
          return;
        }
        let value = modifiedValue.replace(',', '.');
        const indexMoins = modifiedValue.lastIndexOf('-');
        if (indexMoins !== value.length - 1) {
          value = value.substring(indexMoins, modifiedValue.length);
        }
        let newValue = parseFloat(value);
        if (isNaN(newValue) && value.toString().length > 1) {
          newValue = 0;
        }
        if (!this.peutEtreNegatif && newValue < 0) {
          newValue = 0;
        }
        this.$emit('input', newValue);
      },
    },
    taille() {
      if (this.size === null || this.size === undefined) {
        return '';
      }
      return this.size;
    },
  },
  methods: {
    selection() {
      this.isInputActive = true;
      // Pour que le curseur se mette à la fin du chiffre saisie.
      this.$refs.devise.$refs.input.value = ' ';
    },
    catchBlur() {
      this.isInputActive = false;
      if (this.checkBlur) this.$emit('catchBlur');
    },
  },
};
</script>
<style lang="scss">
.inputCurrency input{
  text-align: right;
}

.inputCurrencySaisie input{
  text-align: left;
}

/* webkit solution */
::-webkit-input-placeholder { text-align:left; }
/* mozilla solution */
input[type="text"]::-moz-placeholder { text-align:left; }
input[type="text"]:-moz-placeholder { text-align:left; }
</style>
